import React from 'react';
import {
  List,
  ListItem,
  ListIcon,
  OrderedList,
  UnorderedList,
  Divider,
  Button, FormControl, FormLabel, Input, Stack, InputGroup, InputRightElement, Center, Flex, Heading, Box, useBreakpointValue
} from '@chakra-ui/react'

const ProtectedHeader = () => {
    return (
      <Box p="4" position="sticky" top="0" bg="white" zIndex="banner">
        <Heading textAlign="center">Habits</Heading>
      </Box>
    );
};

export default ProtectedHeader;
